import { render, staticRenderFns } from "./MetricChip.vue?vue&type=template&id=5cde9f40&scoped=true"
import script from "./MetricChip.vue?vue&type=script&lang=js"
export * from "./MetricChip.vue?vue&type=script&lang=js"
import style0 from "./MetricChip.vue?vue&type=style&index=0&id=5cde9f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde9f40",
  null
  
)

export default component.exports